import { defineMessages } from 'react-intl';

export const messages: {
	collapseButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	expandButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	collapseButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.collapse-button-label',
		description: 'Accessible label for the collapsed chevron button in the apps group title.',
		defaultMessage: 'Collapse',
	},
	expandButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.expand-button-label',
		description: 'Accessible label for the expanded chevron button in the apps group title.',
		defaultMessage: 'Expand',
	},
});
